import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_387: DocMigration = {
  maxSchemaVersion: "0.0.387",
  description: "Normalized heel height offsets",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];
      const { roofSideOverrides, roofEdgeOverrides } = roof;

      for (const id in roofSideOverrides) {
        migrateOverrides(roofSideOverrides[id]);
      }

      for (const id in roofEdgeOverrides) {
        migrateOverrides(roofEdgeOverrides[id]);
      }
    }

    return json;
  },
};

function migrateOverrides(overrides: any) {
  if (!overrides) {
    return;
  }

  if (overrides.truncationType === "HIP") {
    overrides.heelHeightOffset = 0;
    overrides.normalizedHeelHeightOffset = true;
  } else if (overrides.truncationType === "NONE") {
    overrides.heelHeightOffset = 1;
    overrides.normalizedHeelHeightOffset = true;
  } else if (overrides.truncationType === "TRUNCATED") {
    overrides.heelHeightOffset = overrides.truncationHeightFactor;
    overrides.normalizedHeelHeightOffset = overrides.truncationNormalizedHeight;
  }

  delete overrides.truncationHeightFactor;
  delete overrides.truncationNormalizedHeight;
}

export default migration_0_0_387;
